import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import MenuIcon from '@material-ui/icons/Menu';
import Stack from '@mui/material/Stack';
import DrawerList from './DrawerList';
import {WHITE_LABEL_LOGO_URL} from '../utils/EnvVars';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function SwipeableTemporaryDrawer(props) {

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });


  
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };


  // React.useEffect(() => {
	// 		if(window.screen.width<700 && props.menuOpen && props.menuOpen===true){
  //       setState({ ...state, ['left']: true });
  //     }
	// }, [props.menuOpen]);

  
  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"      
    >
      <Stack direction="row" spacing={2} style={{margin: 10, justifyContent:'center'}} >
                {
                (window.location.hostname==='localhost' || window.location.hostname==='student.easetolearn.com' || window.location.hostname==='easetolearn.com')?
                <img src={process.env.PUBLIC_URL+"/company-logo.png"} height={50}  />
                :<img src={WHITE_LABEL_LOGO_URL+'/'+window.location.hostname.replace(/\./g,'-')+'.png'} height={50}  />
                }
      </Stack>
      <Divider />

      <DrawerList />

    </div>
  );

  
  return (
    <div>
          <Button style={{color:'#757070'}} onClick={toggleDrawer('left', true)}><MenuIcon /></Button>
          <SwipeableDrawer
            anchor='left'
            open={state['left']}
            onClose={toggleDrawer('left', false)}
            onOpen={toggleDrawer('left', true)}
          >
            {list('left')}
          </SwipeableDrawer>

    </div>
  );
}
